import { Button, Divider, FormControlLabel, Grid, Paper, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import { AccessKey } from "../../Objects/AccessKey";
import { AccessLevel } from "../../Objects/AccessLevel";

export interface AccessLevelCardProps {
    accessLevel: AccessLevel
    accessKeyList: AccessKey[]
    onSave: (accessLevel: AccessLevel) => void
}
export const AccessLevelCard: React.FC<AccessLevelCardProps> = (props) => {
    const [accessLevel, setAccessLevel] = React.useState<AccessLevel>(props.accessLevel)
    const [isEdit, setIsEdit] = React.useState<boolean>(false)

    React.useEffect(() => {
        setAccessLevel(props.accessLevel)
    }, [props.accessLevel])

    React.useEffect(() => {
        if (accessLevel.acky_list.every(value => props.accessLevel.acky_list.includes(value)) && props.accessLevel.acky_list.every(value => accessLevel.acky_list.includes(value))) {
            setIsEdit(false)
        } else {
            setIsEdit(true)
        }
    }, [accessLevel.acky_list, props.accessLevel.acky_list])

    return (
        <Paper
            variant="outlined"
            sx={{
                p: 2
            }}
        >
            <Stack
                spacing={2}
            >
                <Typography variant="h2">{accessLevel.acle_name}</Typography>
                <Divider />
                <Grid container
                    px={2}
                >
                    {props.accessKeyList.map(accessKey => (
                        <Grid item key={accessKey.acky_id} xs={12} sm={6} md={4}>
                            <FormControlLabel
                                label={accessKey.acky_name}
                                control={<Switch
                                    color="secondary"
                                    checked={accessLevel.acky_list.includes(accessKey.acky_id)}
                                    onChange={e => {
                                        let list: number[] = accessLevel.acky_list.filter(value => value != accessKey.acky_id)
                                        if (e.target.checked) {
                                            list.push(accessKey.acky_id)
                                        }
                                        let al: AccessLevel = {
                                            ...accessLevel,
                                            acky_list: list
                                        }
                                        setAccessLevel(al)
                                    }}
                                />}
                            />
                        </Grid>
                    ))}
                </Grid>
                <Divider />
                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="right"
                >
                    <Button
                        variant="outlined"
                        disabled={!isEdit}
                        onClick={() => {
                            setAccessLevel(props.accessLevel)
                        }}
                    >保存された状態に戻す</Button>
                    <Button
                        variant="contained"
                        disabled={!isEdit}
                        onClick={() => {
                            props.onSave(accessLevel)
                        }}
                    >保存</Button>
                </Stack>
            </Stack>
        </Paper>
    )
}